var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconButton48(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5547_67232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#604099"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.525 28.5604C14.6657 28.5264 14.8127 28.5553 14.9291 28.6368L14.995 28.6919L19.2806 32.9768C19.4036 33.1 19.4537 33.2782 19.4129 33.4473C19.3788 33.5883 19.2857 33.7061 19.1598 33.7724L19.0805 33.8058L12.6582 35.9448C12.4783 36.0029 12.2809 35.9563 12.146 35.8238C12.0345 35.712 11.9836 35.5557 12.0046 35.4028L12.026 35.3118L14.1667 28.8918C14.2205 28.7267 14.3561 28.6012 14.525 28.5604ZM27.4796 15.4928C27.6531 15.3285 27.9126 15.308 28.1077 15.4312L28.1869 15.4928L32.4684 19.7748C32.6419 19.9484 32.6612 20.2178 32.5262 20.4126L32.4684 20.4818L21.0512 31.8929C20.8776 32.0663 20.6081 32.0856 20.4133 31.9507L20.344 31.8929L16.0624 27.6128C15.8888 27.4393 15.8696 27.1699 16.0046 26.9751L16.0624 26.9058L27.4796 15.4928ZM29.9805 12.9989C31.3769 11.667 33.5738 11.667 34.9703 12.9989C36.2942 14.3271 36.3415 16.4463 35.1121 17.8311L34.9703 17.9819L34.256 18.6989C34.0824 18.8723 33.8129 18.8916 33.6181 18.7567L33.5488 18.6989L29.2682 14.4188C29.0947 14.2453 29.0754 13.9759 29.2103 13.7811L29.2682 13.7118L29.9805 12.9989Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5547_67232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconButton48);
export default __webpack_public_path__ + "static/media/edit-icon-button-48.ca760ca59c645927a4d83bcce53552bf.svg";
export { ForwardRef as ReactComponent };